<template>
  <div class="cl-inner">
    <div>
      <!-- 搜索 -->
      <div class="search-inner">
        <a-form layout="inline">
          <a-form-item class="name" label="学期">
            <a-select
              showSearch
              placeholder="请选择"
              :filterOption="false"
              :defaultActiveFirstOption="false"
              style="width: 200px"
              @search="changeTerm"
              v-model="queryParam.termId"
              :allowClear="true"
            >
              <a-select-option
                v-for="(item, index) in termList"
                :key="index"
                :value="item.id"
                >{{ item.termName }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item class="name" label="订单编号">
            <a-input
              class="form-cell"
              type="text"
              placeholder="请输入"
              :allowClear="true"
              v-model="queryParam.orderNo"
            ></a-input>
          </a-form-item>
          <a-form-item class="name" label="支付单号">
            <a-input
              class="form-cell"
              type="text"
              placeholder="支付结果中商户单号"
              :allowClear="true"
              v-model="queryParam.transId"
            ></a-input>
          </a-form-item>
          <a-form-item v-if="roleId != 4" class="name" label="课程方种类">
            <a-select
              showSearch
              placeholder="请选择"
              :filterOption="false"
              :defaultActiveFirstOption="false"
              style="width: 200px"
              v-model="queryParam.institutionType"
              :allowClear="true"
            >
              <a-select-option value="2"> 个人老师 </a-select-option>
              <a-select-option value="1"> 社会企业 </a-select-option>
              <a-select-option value="3"> 高校与协会 </a-select-option>
            </a-select>
          </a-form-item>

          <!-- 学校 教育局和平台管理员才有-->
          <c-school-select
            v-if="roleId && (roleId == '6' || roleId == '2')"
            :schoolCode.sync="queryParam.schoolId"
          ></c-school-select>

          <!-- 课程方 -->
          <c-institution-select
            v-if="roleId && roleId != 4"
            :institutionCode.sync="queryParam.institutionId"
          ></c-institution-select>
          <!-- 课程 -->
          <a-form-item class="name" label="课程">
            <a-input placeholder="请输入" v-model="queryParam.courseName">
            </a-input>
            <!-- <a-select
              show-search
              :value="courseValue"
              placeholder="请输入"
              style="width: 200px"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              @search="searchCourse"
              @change="changeCourse"
            >
              <a-select-option v-for="d in courseList" :key="d.id">
                {{ d.courseName }}
              </a-select-option>
            </a-select> -->
          </a-form-item>
          <!-- 班级 -->
          <a-form-item class="name" label="班级">
            <a-input placeholder="请输入" v-model="queryParam.className">
            </a-input>
            <!-- <a-select
              show-search
              :value="value"
              placeholder="请输入"
              style="width: 200px"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              @search="searchClassName"
              @change="changeClassName"
            >
              <a-select-option v-for="d in classNameList" :key="d.id">
                {{ d.className }}
              <a-select-option
                v-for="(item, index) in classNameList"
                :key="index"
                :value="item.id"
                >{{ item.className }}
              </a-select-option>
            </a-select> -->
          </a-form-item>

          <a-form-item class="name" label="学生姓名">
            <a-input
              class="form-cell"
              type="text"
              placeholder="请输入"
              :allowClear="true"
              v-model="queryParam.studentName"
            ></a-input>
          </a-form-item>

          <a-form-item label="选择订单时间">
            <a-range-picker
              :showTime="{ defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')] }"
              format="YYYY-MM-DD HH:mm:ss"
              :placeholder="['开始时间', '结束时间']"
              @change="onChange"
              v-model="queryParam.selectTime"
            />
          </a-form-item>

          <a-form-item class="name" label="订单类型">
            <a-select
              class="form-cell"
              placeholder="请选择"
              v-model="queryParam.orderType"
              :allowClear="true"
            >
              <a-select-option value="1">班级</a-select-option>
              <a-select-option value="2">活动</a-select-option>
              <a-select-option value="3">账单</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item class="name" label="订单状态">
            <a-select
              class="form-cell"
              placeholder="请选择"
              v-model="queryParam.status"
              :allowClear="true"
            >
              <a-select-option value="0">待支付</a-select-option>
              <a-select-option value="1">已完成</a-select-option>
              <a-select-option value="2">已取消</a-select-option>
              <a-select-option value="3">申请退款中</a-select-option>
              <a-select-option value="4">退课成功</a-select-option>
              <a-select-option value="5">已关闭</a-select-option>
              <a-select-option value="6">部分退款成功</a-select-option>
            </a-select>
          </a-form-item>

          <!-- 金额区间 -->
          <a-form-item label="金额区间：" class="w100">
            <a-input-group compact style="width: 100%">
              <a-input-number
                style="width: calc((100% - 30px) / 2)"
                placeholder="最低价"
                :min="0"
                :precision="2"
                v-model="startPrice"
              />
              <a-input
                style="
                  width: 30px;
                  border-left: 0;
                  pointer-events: none;
                  backgroundcolor: #fff;
                "
                placeholder="~"
                disabled
              />
              <a-input-number
                style="width: calc((100% - 30px) / 2); border-left: 0"
                :min="0"
                :precision="2"
                placeholder="最高价"
                v-model="endPrice"
              />
            </a-input-group>
          </a-form-item>

          <!-- 平台管理员才有 -->
          <a-form-item class="name" label="站点" v-if="roleId == '6'">
            <a-select
              showSearch
              placeholder="请输入"
              :filterOption="false"
              :defaultActiveFirstOption="false"
              style="width: 200px"
              @search="changeBureauName"
              v-model="queryParam.bureauId"
              :allowClear="true"
            >
              <a-select-option
                v-for="(item, index) in bureauList"
                :key="index"
                :value="item.id"
                >{{ item.bureauName }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item class="search-oper">
            <a-button type="primary" @click="searchFinOrder()">查询</a-button>
            <a-button @click="clearSelect()">重置</a-button>
            <a
              title="导出限制为10000条，超出限制导出请联系技术支持"
              v-if="roleId == '3' || roleId == '4' || roleId == '6'"
              class="download hover-font-active"
              @click="exportStudent"
              >导出</a
            >
          </a-form-item>
        </a-form>
      </div>

      <!-- 表格数据 -->
      <a-table
        :columns="columns"
        :dataSource="finOrderList"
        :rowKey="(record) => record.id"
        class="c-table"
        :pagination="pagination"
        :loading="loading"
        @change="tableChange"
      >
        <span slot="orderNo" slot-scope="text, record">
          <template>
            <span
              >{{ record.orderNo }}
              <span v-if="record.isCrossSchool == 1" class="cross">
                <img src="/crossSchool.png" style="width: 16px" alt="" />
                <em>跨校订单</em>
              </span>
            </span>
          </template>
        </span>
        <span slot="capacity" slot-scope="text, record">
          <template>
            <span>{{ record.capacity }}</span>
          </template>
        </span>
        <span slot="coursePrice" slot-scope="text, record">
          <template>
            <span>{{ record.coursePrice / 100 }}</span>
          </template>
        </span>
        <span slot="textbookPrice" slot-scope="text, record">
          <template>
            <span>{{ record.textbookPrice / 100 }}</span>
          </template>
        </span>
        <span slot="totalPrice" slot-scope="text, record">
          <template>
            <p>总价：{{ record.totalPrice / 100 }}</p>
            <p>课时费：{{ record.coursePrice / 100 }}</p>
            <p>教材费：{{ record.textbookPrice / 100 }}</p>
          </template>
        </span>
        <span slot="institutionName" slot-scope="text, record">
          <template>
            <span>{{
              record.institutionName ? record.institutionName : '- -'
            }}</span>
          </template>
        </span>
        <span slot="institutionTypeName" slot-scope="text, record">
          <template>
            <span>{{
              record.institutionTypeName ? record.institutionTypeName : '- -'
            }}</span>
          </template>
        </span>
        <span slot="className" slot-scope="text, record">
          <template>
            <span>{{ record.className ? record.className : '- -' }}</span>
          </template>
        </span>
        <span slot="action" slot-scope="text, record">
          <template>
            <a @click="$refs.finOrderForm.init('see', record)">查看</a>
          </template>
        </span>
        <span slot="institutionName" slot-scope="text, record">
          <template>
            <span
              >{{ record.institutionName }}
              <!-- 添加高协标签 -->
              <a-tag v-if="record.institutionType == 3" color="blue">
                高协
              </a-tag>
            </span>
          </template>
        </span>
      </a-table>
      <fin-order-form-modal ref="finOrderForm"></fin-order-form-modal>
    </div>
  </div>
</template>
<script>
import finOrder from '../../api/finOrder'

import bureau from '../../api/bureau'

import school from '../../api/school'

import FinOrderFormModal from './FinOrderFormModal'

import CSchoolSelect from '../../components/CSchoolSelect'

import CInstitutionSelect from '../../components/CInstitutionSelect'

import moment from 'moment'
import Vue from 'vue'
export default {
  name: 'finOrderList',
  data() {
    return {
      finOrderList: [], //订单数据
      columns: [
        {
          title: '订单编号',
          dataIndex: 'orderNo',
          scopedSlots: { customRender: 'orderNo' },
          width: 180,
        },
        {
          title: '订单类型',
          dataIndex: 'orderTypeText',
        },
        {
          title: '订单标题',
          dataIndex: 'orderTitle',
        },
        {
          title: '订单状态',
          dataIndex: 'statusText',
        },
        {
          title: '课时总价/元',
          dataIndex: 'totalPrice',
          scopedSlots: { customRender: 'totalPrice' },
          width: 110,
        },
        // {
        //   title: '课时总价/元',
        //   dataIndex: 'coursePrice',
        //   scopedSlots: { customRender: 'coursePrice' },
        //   width: 90,
        // },
        {
          title: '班级学校',
          dataIndex: 'classSchool',
          width: 120,
        },
        // {
        //   title: '教材/教具价格/元',
        //   dataIndex: 'textbookPrice',
        //   scopedSlots: { customRender: 'textbookPrice' },
        //   width: 120,
        // },

        {
          title: '报名学员学校',
          dataIndex: 'studentSchool',
        },
        {
          title: '学生姓名',
          dataIndex: 'studentName',
        },
        {
          title: '课程方',
          dataIndex: 'institutionName',
          scopedSlots: { customRender: 'institutionName' },
        },
        {
          title: '课程方种类',
          dataIndex: 'institutionTypeName',
          scopedSlots: { customRender: 'institutionTypeName' },
        },
        {
          title: '课程名称',
          dataIndex: 'courseName',
          scopedSlots: { customRender: 'courseName' },
        },
        {
          title: '班级名称',
          dataIndex: 'className',
          scopedSlots: { customRender: 'className' },
        },
        {
          title: '创建时间',
          dataIndex: 'gmtCreate',
          sorter: true,
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      startPrice: '', //最小价格
      endPrice: '', //最大价格
      queryParam: {}, //查询参数
      pagination: {
        pageSize: 10,
        total: 0,
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
        current: 1,
        currentPage: 1,
      }, //分页数据对象
      loading: true, //状态loading加载
      classNameList: [], //班级搜索的集合
      bureauList: [], //站点的集合
      value: undefined, //班级
      roleId: '', //权限id
      courseValue: undefined, //课程
      courseList: [],
      termList: [],
    }
  },
  components: {
    FinOrderFormModal,
    CSchoolSelect,
    CInstitutionSelect,
  },
  methods: {
    moment,
    //导出
    exportStudent(e) {
      let _this = this;
      this.$confirm({
        title: '注意',
        okText: '确定',
        cancelText: '取消',
        icon:'exclamation-circle',
        content: '注意：仅支持导出1万条数据记录，如需导出更多数据请提出人工导出申请',
        onOk() {
          _this.$message.success('导出中...')
      finOrder.exportOrder(_this.queryParam).then((res) => {
        const url = window.URL.createObjectURL(res.data)
        let dom = document.createElement('a')
        dom.style.display = 'none'
        dom.href = url
        dom.setAttribute('download', '订单列表.xlsx')
        document.body.appendChild(dom)
        dom.click()
      })
        },
      })
    },

    //table发生该表，分页，排序
    tableChange(pagination, filters, sorter) {
      // let obj = this.queryParam
      let obj = JSON.parse(JSON.stringify(this.queryParam))
      obj.currentPage = pagination.current
      obj.pageSize = pagination.pageSize
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        obj
      )}`
      //存在排序的时候
      if (sorter && sorter.columnKey) {
        obj.sorter = `${sorter.columnKey}-${
          sorter.order == 'ascend' ? 'asc' : 'desc'
        }`
      }
      this.getFinOrderList(obj)
    },

    //选择时间改变触发
    onChange(value, dateString) {
      //赋值筛选时间
      this.queryParam.minGmtCreate = dateString[0]
      this.queryParam.maxGmtCreate = dateString[1]
    },

    //重置
    clearSelect() {
      this.queryParam = {}
      this.startPrice = ''
      this.endPrice = ''
      this.value = undefined
      this.classNameList = []
      this.courseValue = undefined
      this.courseList = []
      //查询订单列表
      this.getFinOrderList()
    },
    //查询订单列表
    searchFinOrder() {
      console.log('this.queryParam', this.queryParam)
      if (this.queryParam && this.queryParam.buyerName) {
        this.queryParam.buyerName = this.queryParam.buyerName.trim() || ''
      }
      if (this.queryParam && this.queryParam.orderNo) {
        this.queryParam.orderNo = this.queryParam.orderNo.trim() || ''
      }
      console.log('queryParam', this.queryParam)
      var queryParams = JSON.parse(JSON.stringify(this.queryParam))
      delete queryParams.selectTime
      queryParams.currentPage = 1
      queryParams.pageSize = 10
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        queryParams
      )}`
      if (this.startPrice == '' && this.endPrice == '') {
        this.getFinOrderList(queryParams)
      } else {
        if (this.startPrice > this.endPrice) {
          this.$message.error('最低价不能大于最高价')
        } else {
          this.queryParam.startPrice = this.startPrice * 100
          this.queryParam.endPrice = this.endPrice * 100
          queryParams.startPrice = Math.round(this.startPrice * 100)
          queryParams.endPrice = Math.round(this.endPrice * 100)
          this.getFinOrderList(queryParams)
        }
      }
    },

    //订单列表接口方法
    getFinOrderList(params) {
      this.loading = true
      if (this.queryParam.institutionType) {
        params = { ...params, sourceType: 2 }
      }

      console.log('params', params)
      finOrder.getFinOrderList(params).then((res) => {
        this.finOrderList = res.data.list
        console.log('this.finOrderList', this.finOrderList)
        this.loading = false
        //分页信息
        this.pagination = res.data.pagination
      })
    },

    //刷新订单列表
    refreshFinOrder() {
      this.getFinOrderList()
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    //课程
    searchCourse(value) {
      console.log('value', value)
      if (!value) {
        return
      }
      value = value ? value.trim() : ''

      let self = this
      let obj = {
        courseName: value,
      }
      finOrder.searchCourseName(obj).then((res) => {
        self.courseList = res.data
        console.log(self.courseList)
      })
    },
    changeCourse(value) {
      console.log('changeCoursevalue', value)
      this.courseValue = value
      this.queryParam.courseId = value
    },
    //班级
    changeClassName(value) {
      console.log('value', value)
      this.value = value
      this.queryParam.classId = value
    },
    changeTerm(value) {
      this.value = value
      this.queryParam.termId = value
    },
    //查询班级
    searchClassName(value) {
      this.className = value
      console.log('value', value)
      if (!value) {
        return
      }
      value = value ? value.trim() : ''

      let self = this
      let obj = {
        className: value,
      }
      finOrder.searchClassName(obj).then((res) => {
        self.classNameList = res.data
        console.log(self.classNameList)
      })
    },

    //查询站点
    changeBureauName(value) {
      value = value ? value.trim() : ''
      let self = this
      let req = {
        bureauName: value,
      }
      bureau.selectBureau(req).then((res) => {
        self.bureauList = res.data
      })
    },
    //是否有操作权限
    judgeIsOper() {
      this.$store.dispatch('getUserInfo').then(async (res) => {
        //只有才有权限
        this.roleId = res.accRole.id.toString()
        //平台管理员
        if (this.roleId == '6') {
          this.columns.splice(this.columns.length - 2, 0, {
            title: '站点',
            dataIndex: 'bureauName',
            width: 150,
          })
          if (!this.$route.query.params) {
            await school.searchSchool({ schoolName: '' }).then((res) => {
              this.queryParam.schoolId = res.data[0].id
            })
          }
        }
        this.getFinOrderList(this.queryParam)
      })
    },
  },

  created() {
    if (this.$route.query.params) {
      this.queryParam = JSON.parse(this.$route.query.params)
    } else {
      this.queryParam = {}
    }
    this.termList = Vue.ls.get('term')
    //查询订单列表

    this.changeClassName()
    this.changeBureauName()
    this.judgeIsOper()
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';

.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
}

.search-oper {
  button {
    margin: 0px 5px;
  }
}

.list-oper {
  margin: 20px 0px 30px;
}

.person-scope {
  width: 100px;
  text-align: center;
}

.max-person {
  border-left: none;
}

.c-table {
  margin-top: 20px;
}

.person-gap {
  width: 30px;
  border-left: 0;
  pointer-events: none;
  background: #fff;
}
.download {
  display: inline-block;
  margin-left: 20px;
  text-decoration: underline;
  color: $primary-color-dark;
  position: relative;
}
.cross {
  margin-left: 5px;
  color: #d71616 !important;
  em {
    border: 1.5px solid #d71616;
    border-radius: 4px;
    margin-left: 2px;
    font-style: normal;
  }
}
</style>
